export default e => e.target.value = e.target.value.replace(/[^A-Za-z]/, '');